import { apiC } from "@services/api/apiC";
import { type ConversationCourse, type Conversation, type CreateConversationForStudentRequestFlat, type CreateMessageForConversationRequestFlat, type GetConversationsForStudentRequestFlat, type GetConversationsForStudentSuccess, type GetConversationTypesForStudentRequestFlat, type GetMessagesForConversationRequestFlat, type GetMessagesForConversationSuccess, type ConversationType, type GetConversationTypesForStudentSuccess, type GetStudentInterventionSummaryRequestFlat, type StudentInterventionSummary, type UpdateStudentInterventionSummaryRequestFlat, type UpdateStudentInterventionSummarySuccess, ConversationMessage } from "@godalming/api-types"

export async function fetchStudentConversations(params: GetConversationsForStudentRequestFlat): Promise<GetConversationsForStudentSuccess> {
    try {
        const response = await apiC.get<Conversation[]>(`/StudentConversationList`, { 
            params: {
                ...params
            } 
        });
        return response.data
    } catch (error) {
        console.error("Error fetching student conversations:", error);
        throw error;
    }
}

export async function fetchConversationMessages(params: GetMessagesForConversationRequestFlat): Promise<GetMessagesForConversationSuccess> {
    try {
        const response = await apiC.get<ConversationMessage[]>(`/StudentConversationMessageList`, {
            params: {
                ...params
            }
        });
        return response.data
    } catch (error) {
        console.error("Error fetching conversation messages:", error);
        throw error;
    }
}

export async function fetchStudentConversationCreateTypeList(params: GetConversationTypesForStudentRequestFlat): Promise<ConversationType[]> {
    try {
        const response = await apiC.get(`/StudentConversationCreateTypeList`, {
            params: {
                ...params
            }
        });
        console.log("Fetched conversation create types:", response.data.studentConversationCreateList);
        return response.data.studentConversationCreateList as ConversationType[]
    } catch (error) {
        console.error("Error fetching student conversation create type list:", error);
        throw error;
    }
}

export async function fetchStudentConversationCourseList(params: GetConversationTypesForStudentRequestFlat): Promise<ConversationCourse[]> {
    try {
        const response = await apiC.get(`/StudentConversationCreateTypeList`, {
            params: {
                ...params
            }
        });
        return response.data.studentConversationCourseList as ConversationCourse[]
    } catch (error) {
        console.error("Error fetching student conversation course list:", error);
        throw error;
    }
}

export async function postConversationMessage(params: CreateMessageForConversationRequestFlat) {
    try {
        const response = await apiC.post(`/StudentConversationMessageAdd`, params);
        return response.data
    } catch (error) {
        console.error("Error posting conversation message:", error);
        throw error;
    }
}

export async function postConversation(params: CreateConversationForStudentRequestFlat) {
    try {
        const response = await apiC.post(`/StudentConversationAdd`, params);
        return response.data
    } catch (error) {
        console.error("Error posting conversation:", error);
        throw error;
    }
}

export async function fetchStudentInterventionSummary(params: GetStudentInterventionSummaryRequestFlat): Promise<StudentInterventionSummary> {
    try {
        const response = await apiC.get(`/StudentSummaryNeedIntervention`, { 
            params: {
                ...params
            } 
        });
        return response.data as StudentInterventionSummary
    } catch (error) {
        console.error("Error fetching student intervention summary:", error);
        throw error;
    }
}

export async function updateStudentInterventionSummary(params: UpdateStudentInterventionSummaryRequestFlat): Promise<UpdateStudentInterventionSummarySuccess> {
    try {
        const response = await apiC.post(`/StudentSummaryNeedInterventionUpdate`, {
            ...params
        });
        return response.data as UpdateStudentInterventionSummarySuccess
    } catch (error) {
        console.error("Error updating student intervention summary:", error);
        throw error;
    }
}
